module.exports = __webpack_public_path__ + "logo.acc4da3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/widgets/widget_logo/logo.svg
// module id = 1349
// module chunks = 1